import React from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import * as r from "../../js/constants/routes";
import { SelectURLGrid } from "../Widgets/Custom Inputs/Select";
import { requiredCell } from "../../js/utils/inputValidations";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import { useEditionRightsPerUserStatus } from "../../js/utils/customHooks";
import { filterValidUser } from "./cst_DataGrid";
import { ListItem, ListItemText } from "@mui/material";

/** When a branch is selected and given to the branch manager, the access will be provided to entities that have the qualified branch (in the edition, EntityEditionForm). Thus : */
const BranchManagerGrid = ({ label = t("grid.title.BranchManagers"), baseURL }) => {
    const apiRef = useGridApiRef();
    const cellFocusField = "OTUser_select";
    const editingRights = useEditionRightsPerUserStatus(["BranchManager"]);
    const gridSpecificColumns = [
        {
            field: "OTUser_IGG",
            headerName: "IGG",
            flex: 0.5,
            valueGetter: params => params.row.OTUser_select?.IGG,
            sortable: false,
        },
        {
            field: "OTUser_select",
            headerName: t("field.User"),
            flex: 1,
            editable: true,
            sortable: false,
            valueFormatter: params => params.value?.Name,
            renderEditCell: params => (
                <SelectURLGrid
                    fieldName={"OTUserID"}
                    paramURL={filterValidUser}
                    selectRoute={"SelectDetail"}
                    URL={r.oTUser}
                    getOptionLabel={option => option.Name ?? option.IGG}
                    filterOptions={options => options}
                    renderOption={(props, option) => (
                        <ListItem {...props} key={option.ObjectID}>
                            <ListItemText
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                }}
                                inset
                                primary={option.Name}
                                secondary={option.IGG}
                            />
                        </ListItem>
                    )}
                    {...params}
                />
            ),
            preProcessEditCellProps: params => {
                const hasError = requiredCell(
                    params,
                    apiRef,
                    "User",
                    "OTUser_select"
                );
                return { ...params.props, error: hasError };
            },
            valueSetter: params => ({
                ...params.row,
                EMail: params.value.EMail,
            }),
        },
        {
            field: "OTUserID",
            editable: false,
        },
        {
            field: "EMail",
            headerName: "Email",
            flex: 0.5,
            valueGetter: params => params.row.OTUser_select?.EMail,
            sortable: false,
        },
        {
            field: "Branch_select",
            headerName: t("field.Branch"),
            sortable: false,
            flex: 1,
            width: 200,
            editable: true,
            valueFormatter: params => params.value?.Value,
            renderEditCell: params => (
                <SelectURLGrid
                    fieldName={"BranchID"}
                    URL={r.branch.route}
                    {...params}
                />
            ),
            preProcessEditCellProps: params => {
                const hasError = requiredCell(
                    params,
                    apiRef,
                    "Branch",
                    "Branch_select"
                );
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "BranchID",
            valueGetter: params => params.row?.Branch_select?.ObjectID,
        },
    ];

    return (
        <DataGridComponent
            apiRef={apiRef}
            baseURL={baseURL}
            columnVisibilityModel={{
                "BranchID": false,
                "OTUserID": false
            }}
            cellFocusField={cellFocusField}
            label={label}
            gridSpecificColumns={gridSpecificColumns}
            isEditDisabled={true}
            initialState={{
                sorting: {
                    sortModel: [{ field: "OTUserID", sort: "asc" }],
                },
            }}
            editingRights={editingRights}
        />
    );
};

export default BranchManagerGrid;
